package ai.flowstorm.studio.ui.data

import ai.flowstorm.common.ui.CodeEditor
import ai.flowstorm.common.ui.Panel
import ai.flowstorm.common.ui.UiHelpers
import io.kvision.panel.SimplePanel
import io.kvision.panel.simplePanel
import io.kvision.utils.vh
import kotlinx.coroutines.MainScope

class PlaylistTestPanel(override val caption: String = "Playlist test") : SimplePanel(), Panel {
    val codeEditor = CodeEditor(className = "panel-view-context").apply {
        this.readOnly = true
        height = 35.vh
        paddingLeft = UiHelpers.spacing
        paddingRight = UiHelpers.spacing
    }
    private val playlistTestEditor = PlaylistTestEditor { results ->
        codeEditor.set(results.sortedBy { it.index.toInt() }.joinToString("\n") { result ->
            result.session
        })
    }
    val mainScope = MainScope()

    init {
        add(playlistTestEditor)
        simplePanel( className = "examples-editor") {
            this.add(codeEditor)
        }
    }
}